export const DS_USER_SEE_SOT_FLOW = 'ds_user_see_SoT_flow';
export const SOT_GET_STARTED = 'sot_get_started';
export const SOT_CREATE_ACCOUNT = 'sot_create_account';
export const SOT_GET_OTP = 'sot_get_otp';
export const SOT_VERIFIED_OTP = 'sot_verified_otp';
export const SOT_SUBMIT_INTRO = 'sot_submit_intro';
export const SOT_CLOSE_FOUNDER_VIDEO = 'sot_close_founder_video';
